import { render } from "./BrazilMap.vue?vue&type=template&id=08bf07d8&scoped=true"
import script from "./BrazilMap.vue?vue&type=script&lang=js"
export * from "./BrazilMap.vue?vue&type=script&lang=js"

import "./BrazilMap.vue?vue&type=style&index=0&id=08bf07d8&scoped=true&lang=css"

import exportComponent from "Z:\\Backups\\Backup Site tecmar\\07.10.2026\\tecmar-transportes-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bf07d8"]])

export default __exports__